import { Skeleton } from "@/components/ui/skeleton"

const STORE_PLACEHOLDERS = [1, 2, 3, 4] as const
const RATING_PLACEHOLDERS = [1, 2, 3, 4, 5] as const

export function CategorySidebarSkeleton(): React.ReactNode {
  return (
    <aside className='h-fit space-y-5 rounded-md border border-gray-200 bg-gray-50 p-4 lg:sticky lg:top-24 lg:block'>
      <div className='space-y-2'>
        <Skeleton className='h-4 w-16' />
        <Skeleton className='h-10 w-full' />
      </div>

      <div className='space-y-2'>
        <Skeleton className='h-4 w-24' />
        <div className='space-y-3'>
          <Skeleton className='h-5 w-full' />
          <div className='flex items-center justify-between'>
            <Skeleton className='h-4 w-14' />
            <Skeleton className='h-4 w-14' />
          </div>
        </div>
      </div>

      <div className='space-y-2'>
        <Skeleton className='h-4 w-12' />
        <div className='space-y-2'>
          {STORE_PLACEHOLDERS.map((placeholder) => (
            <div className='flex items-center gap-2' key={placeholder}>
              <Skeleton className='h-4 w-4' />
              <Skeleton className='h-4 w-28' />
            </div>
          ))}
        </div>
      </div>

      <div className='space-y-2'>
        <Skeleton className='h-4 w-14' />
        <Skeleton className='h-10 w-full' />
        <Skeleton className='h-3 w-40' />
      </div>

      <div className='space-y-2'>
        <Skeleton className='h-4 w-24' />
        <div className='space-y-1'>
          <Skeleton className='h-8 w-full' />
          {RATING_PLACEHOLDERS.map((placeholder) => (
            <Skeleton className='h-8 w-full' key={placeholder} />
          ))}
        </div>
      </div>

      <div className='flex items-center gap-2'>
        <Skeleton className='h-4 w-4' />
        <Skeleton className='h-4 w-32' />
      </div>
    </aside>
  )
}
